module.exports = __webpack_public_path__ + "static/media/track-grey.697b088f.svg";